"use client";

import Link from "next/link";
import { Josefin_Sans } from "next/font/google"; // Import the font
import { useUser } from "../contexts/UserProviderContext";
import { Facebook, Instagram, Youtube } from "lucide-react";

const josefinSans = Josefin_Sans({ subsets: ["latin"], weight: "400" });

export default function Footer({
  pageContentEdit,
  toggleContentEdit,
  pageEditable = false,
}) {
  const { user, loading } = useUser();

  const isAdmin = !loading && user && user.permissions?.includes("Admin");

  return (
    <footer
      className={`${josefinSans.className} bg-primaryyellow text-center py-[40px] w-[100%]`}
    >
      {/* Social Media Icons */}
      <div className="flex justify-center space-x-6 mb-6">
        <a
          href="https://www.facebook.com/people/Desert-Blossom-Homeschool-Resource-Center/61574085892483/#"
          target="_blank"
          rel="noopener noreferrer"
          className="text-black hover:text-gray-600 transition-colors duration-200"
          aria-label="Visit our Facebook page"
        >
          <Facebook size={28} />
        </a>
        <a
          href="https://www.instagram.com/homeschooldb/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-black hover:text-gray-600 transition-colors duration-200"
          aria-label="Visit our Instagram page"
        >
          <Instagram size={28} />
        </a>
        <a
          href="https://www.youtube.com/channel/UCH9owpHwXepc1XNsuq-ftZA"
          target="_blank"
          rel="noopener noreferrer"
          className="text-black hover:text-gray-600 transition-colors duration-200"
          aria-label="Visit our YouTube channel"
        >
          <Youtube size={28} />
        </a>
        <a
          href="https://www.zeffy.com/donation-form/donate-to-make-a-difference-13547"
          target="_blank"
          rel="noopener noreferrer"
          className="text-black underline hover:text-gray-600 transition-colors duration-200"
        >
          Donate
        </a>
      </div>
      All Rights Reserved &copy; {new Date().getFullYear()}
      {!loading && user && (
        <span>
          {"  "}|{"  "}
          <a href="/unsubscribe" className="underline cursor-pointer">
            Unsubscribe
          </a>
        </span>
      )}
      {isAdmin && pageEditable && (
        <span>
          <span className="mx-2">|</span>{" "}
          <span
            className="text-black hover:text-gray-800 transition cursor-pointer underline"
            onClick={() => {
              if (pageContentEdit) {
                const shouldReload = window.confirm(
                  "You might have unsaved changes. Are you sure you want to refresh?",
                );
                if (shouldReload) window.location.reload();
              } else {
                toggleContentEdit();
              }
            }}
          >
            {pageContentEdit ? "Done Editing" : "Edit Page"}
          </span>
        </span>
      )}
      {isAdmin && (
        <span>
          <span className="mx-2">|</span>{" "}
          <a
            href="/admin"
            className="text-black-600 hover:text-black-800 transition underline"
          >
            Admin Page
          </a>
        </span>
      )}
    </footer>
  );
}
